import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Menu, Button } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import clsx from 'clsx';
import { HeaderIcons, Icons } from '@/assets';
import { playNotificationSound } from '@/assets/sounds/notificationSound.js';
import NotificationCard from '@/ctComponents/NotificationCard/NotificationCard';
import { v4 as uuidv4 } from 'uuid';
import { createPortal } from 'react-dom';
import {
  SaveData,
  getNotifications,
  getNotificationsUnSeen,
  getUserSettings,
  postNotificationsSeenAll,
  seenNotif,
  setUserSettings,
  SaveApiResMessage,
  getContainerData,
  unSeenNotif,
} from '@/actions';
import { _get } from '@/actions/Helper';
import Card from './Card';

import styles from './styles';
import { ReactSVG } from 'react-svg';
import { usePusher } from '@/App';
import { useNotify } from 'react-admin';
import useUrlManager from '@/hooks/useUrlManager';
import LoadingV2 from '../Loading';

export default (props) => {
  const history = useHistory();
  const notif = useSelector((state) => state.reducer.notif || {});
  const user_id = useSelector((state) => state.reducer.user.id);
  const notificationCount = useSelector(
    (state) => state.reducer.notificationCount
  );
  const { location, isInChat, getCurrentChatId } = useUrlManager();

  const currentLocationRef = useRef(location);

  useEffect(() => {
    currentLocationRef.current = location;
  }, [location]);
  const cls = styles({ notif });
  const [notifMute, setNotifMute] = React.useState();
  const [notifCount, setNotifCount] = React.useState(0);
  const notify = useNotify();
  const [notifications, setNotifications] = useState([]);
  const [clearingAll, setClearingAll] = useState(false);
  const wrapperRef = useRef(null);
  const [state, setState] = React.useState({
    loading: true,
    DATA: [],
    unSeenDATA: [],
    menu: null,
  });
  const [selectedNotifTab, setSelectedNotifTab] = React.useState('all');

  const hasApiResMessage = useSelector((state) => state.reducer.apiResMessage);
  useEffect(() => {}, [hasApiResMessage]);

  const [page, setPage] = React.useState(1);
  const [hasMore, setHasMore] = React.useState(true);

  const contentRef = React.useRef();
  const isLoadingRef = React.useRef(false);
  const scrollPositionRef = React.useRef(0);
  const previousTabRef = React.useRef(selectedNotifTab);
  const previousNotificationCountRef = React.useRef(notificationCount);
  const [shouldScrollToTopRef, setShouldScrollToTopRef] = React.useState(false);
  const pendingRequestsRef = React.useRef(new Map()); // Track pending requests by notification ID

  const { channels } = usePusher();

  useEffect(() => {
    getUserSettings('notifMute')
      .then((res) => {
        const resData = res.data?.settings?.data;

        if (resData === null || resData === undefined || resData === false) {
          setNotifMute(false);
        } else if (resData === true) {
          setNotifMute(true);
        }
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        // setLoading(false);
      });
  }, [state.menu]);

  const handleMuteNotif = () => {
    const dataMuteNotif = !notifMute;

    const req = {
      key: 'notifMute',
      data: dataMuteNotif,
    };

    setUserSettings(req)
      .then((res) => {
        if (res?.data?.settings?.data === true) {
          setNotifMute(true);
          SaveApiResMessage({
            title: res?.data?.messageHeader,
            message: 'Your notifications have been muted.',
            mode: 'success',
          });
        } else {
          setNotifMute(false);
          SaveApiResMessage({
            title: res?.data?.messageHeader,
            message: 'Your notifications have been unmuted.',
            mode: 'success',
          });
        }
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        // setLoading(false);
      });
  };

  useEffect(() => {
    if (hasApiResMessage) {
      const resMessage = {
        id: uuidv4(),
        title: hasApiResMessage?.title || 'Notification',
        message: hasApiResMessage?.message,
        wrapper:
          hasApiResMessage?.mode === 'success'
            ? '#717784'
            : hasApiResMessage?.mode === 'error'
            ? '#FFAD00'
            : hasApiResMessage?.mode === 'warning'
            ? '#FFAD00'
            : hasApiResMessage?.mode === 'info'
            ? '#717784'
            : '#ccc',
        shadow:
          hasApiResMessage?.mode === 'success'
            ? '#EFF0F2'
            : hasApiResMessage?.mode === 'error'
            ? '#FFECC0'
            : hasApiResMessage?.mode === 'warning'
            ? '#FFECC0'
            : hasApiResMessage?.mode === 'info'
            ? '#EFF0F2'
            : '#eee',
        queryParams: null,
        autoClose: true,
      };
      setNotifications((prev) => [resMessage, ...prev]);
    }
  }, [hasApiResMessage]);

  useEffect(() => {
    if (channels?.privateChannel) {
      const handleNewOrder = (data) => {
        SaveData({ notificationCount: data?.message?.notification_count });
        // if (notifMute === false) {
        //   playNotificationSound();
        // }
        setNotifCount(data?.message?.notification_count);
      };

      channels.privateChannel.bind('ContainerAppointmentUpdate', (data) => {
        SaveData({ containerUpdateEvent: data });
        SaveData({ notificationCount: data?.message?.notification_count });

        const shouldSkipNotification =
          ((data?.message?.status === 'RESERVATION_FAILED' ||
            data?.message?.status === 'EDITING_FAILED') &&
            data?.message?.originSource === 'AUTOBOOK') ||
          data?.message?.withToast === false;
        console.log('shouldSkipNotification', shouldSkipNotification, { data });
        if (shouldSkipNotification) {
          return; // Skip showing notification
        }

        setTimeout(() => {
          const notif = getColor(
            data?.message?.status,
            data?.message?.container,
            data?.message.specification_id,
            data?.message.company_id,
            data?.message.container_id || data?.message.container,
            data.message.isLiveUnload ? data.message.isLiveUnload : null,
            data.message.cabinId ? data.message.cabinId : null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            data.message.toast_message
          );

          setNotifications((prev) => [notif, ...prev]);
          setShouldScrollToTopRef(true);
        }, 1500);
      });
      //

      channels.privateChannel.bind('NotificationCount', (data) => {
        handleNewOrder(data);
        const type = data?.message?.type;
        setTimeout(() => {
          const notif = getColor(
            type,
            data?.message?.container,
            data?.message?.specification_id,
            data?.message?.company_id,
            data?.message?.container_id,
            null,
            null,
            data?.message.title,
            data?.user_id,
            data?.message?.data?.order_id,
            data?.message.body,
            data?.message?.data?.opponent,
            data?.event,
            null,
            data?.message.toast_message
          );

          if (notif) {
            setNotifications((prev) => [notif, ...prev]);
            setShouldScrollToTopRef(true);
          }
        }, 100);
      });

      return () => {
        channels.privateChannel.unbind('ContainerAppointmentUpdate');
        channels.privateChannel.unbind('NotificationCount');
      };
    }
  }, [channels]);

  const getQueryParams = (
    status,
    order_id,
    specification_id,
    company_id,
    container_id,
    isLiveUnload,
    cabinId
  ) => {
    if (status === 'chat' || status === 'order' || status === 'request') {
      return `${order_id}-empty-${user_id}`;
    }

    const params = new URLSearchParams({
      apiData: JSON.stringify({
        size: specification_id,
        ssl: company_id,
        containerId: container_id,
        isLiveUnload: isLiveUnload,
        cabinId: cabinId,
      }),
    });

    return params.toString();
  };

  const getColor = useCallback(
    (
      status,
      container,
      specification_id,
      company_id,
      container_id,
      isLiveUnload,
      cabinId,
      title,
      user_id,
      order_id,
      body,
      opponent,
      event,
      currentLocation = currentLocationRef.current,
      toast_message
    ) => {
      if (notifMute === false && event !== 'NotificationCount') {
        playNotificationSound();
      }

      const queryParams = getQueryParams(
        status,
        order_id,
        specification_id,
        company_id,
        container_id,
        isLiveUnload,
        cabinId
      );

      const checkIfInChat = (chatId, loc = currentLocation) => {
        const pathSegments = loc.pathname
          .split('/')
          .filter((segment) => segment !== '');
        const isChatRoute =
          pathSegments[0] === 'inbox' && pathSegments[1] === 'chat';
        return chatId ? isChatRoute && pathSegments[2] === chatId : isChatRoute;
      };

      switch (status) {
        case 'RESERVATION_PENDING_APPROVAL':
          return {
            id: uuidv4(),
            title: 'Appointment Scheduling Pending',
            message:
              toast_message ||
              `The appointment for ${container} is pending terminal approval.`,
            wrapper: '#717784',
            shadow: '#EFF0F2',
            queryParams,
          };
        case 'EDITING_PENDING_APPROVAL':
          return {
            id: uuidv4(),
            title: 'Appointment Rescheduling Pending',
            message:
              toast_message ||
              `The rescheduling request for ${container} is pending terminal approval.`,
            wrapper: '#717784',
            shadow: '#EFF0F2',
            queryParams,
          };
        case 'CANCELLATION_PENDING_APPROVAL':
          return {
            id: uuidv4(),
            title: 'Appointment Cancellation Pending',
            message:
              toast_message ||
              `The cancellation request for ${container} is pending terminal approval.`,
            wrapper: '#717784',
            shadow: '#EFF0F2',
            queryParams,
          };
        case 'RESERVATION_FAILED':
          return {
            id: uuidv4(),
            title: 'Appointment Scheduling Failed',
            message:
              toast_message ||
              `The appointment for ${container} could not be scheduled.`,
            wrapper: '#FFAD00',
            shadow: '#FFECC0',
            queryParams,
          };
        case 'EDITING_FAILED':
          return {
            id: uuidv4(),
            title: 'Appointment Rescheduling Failed',
            message:
              toast_message ||
              `The appointment for ${container} could not be rescheduled.`,
            wrapper: '#FFAD00',
            shadow: '#FFECC0',
            queryParams,
          };
        case 'CANCELLATION_FAILED':
          return {
            id: uuidv4(),
            title: 'Appointment Cancellation Failed',
            message:
              toast_message ||
              `The appointment for ${container} could not be cancelled.`,
            wrapper: '#FFAD00',
            shadow: '#FFECC0',
            queryParams,
          };

        case 'RESERVED':
          return {
            id: uuidv4(),
            title: 'Appointment Reserved',
            message:
              toast_message ||
              `The appointment for ${container} has been successfully reserved.`,
            wrapper: '#1FC16B',
            shadow: '#E0FAEC',
            queryParams,
          };
        case 'CANCELED':
          return {
            id: uuidv4(),
            title: 'Appointment Cancelled',
            message:
              toast_message ||
              `The appointment for ${container} has been cancelled.`,
            wrapper: '#FB3748',
            shadow: '#FFEBEC',
            queryParams,
          };
        case 'REJECTED':
          return {
            id: uuidv4(),
            title: 'Appointment Rejected',
            message:
              toast_message ||
              `The appointment for ${container} has been rejected.`,
            wrapper: '#FB3748',
            shadow: '#FFEBEC',
            queryParams,
          };
        case 'EDITED':
          return {
            id: uuidv4(),
            title: 'Appointment Rescheduled',
            message:
              toast_message ||
              `The appointment for ${container} has been successfully
              rescheduled.`,
            wrapper: '#335CFF',
            shadow: '#EBF1FF',
            queryParams,
          };
        case 'chat':
          if (checkIfInChat(queryParams, currentLocation)) {
            return null;
          } else {
            return {
              id: uuidv4(),
              title: title,
              message: body,
              wrapper: '#ccc',
              shadow: '#eee',
              queryParams,
              status,
              opponent: opponent,
              autoClose: true,
            };
          }
        case 'order':
          return {
            id: uuidv4(),
            title: title,
            message: body,
            wrapper: '#ccc',
            shadow: '#eee',
            queryParams,
            status,
          };
        case 'request':
          return {
            id: uuidv4(),
            title: title,
            message: body,
            wrapper: '#ccc',
            shadow: '#eee',
            queryParams,
            status,
          };
        default:
          return null;
      }
    },
    [notifMute, user_id, currentLocationRef]
  );

  const loadMoreNotifications = useCallback(
    (pageNum) => {
      // Prevent multiple API calls while one is already in progress
      if (state.loadingLazy || isLoadingRef.current) {
        return;
      }

      isLoadingRef.current = true;
      const apiCall =
        selectedNotifTab === 'all' ? getNotifications : getNotificationsUnSeen;
      setState((prev) => ({ ...prev, loadingLazy: true }));

      apiCall(pageNum)
        .then((res) => {
          const newData = res?.notifications?.data || [];
          const currentPage = res?.notifications?.current_page || 1;
          const lastPage = res?.notifications?.last_page || 1;
          setNotifCount(res?.unread_count);

          setState((prev) => ({
            ...prev,
            DATA:
              selectedNotifTab === 'all'
                ? pageNum === 1
                  ? newData
                  : [...(prev.DATA || []), ...newData]
                : prev.DATA,
            unSeenDATA:
              selectedNotifTab === 'unread'
                ? pageNum === 1
                  ? newData
                  : [...(prev.unSeenDATA || []), ...newData]
                : prev.unSeenDATA,
            loadingLazy: false,
            loading: false,
          }));

          setPage(currentPage);
          setHasMore(currentPage < lastPage);
          isLoadingRef.current = false;
          previousNotificationCountRef.current = res?.unread_count;
        })
        .catch((error) => {
          console.error('Error loading notifications:', error);
          setState((prev) => ({
            ...prev,
            loadingLazy: false,
            loading: false,
          }));
          isLoadingRef.current = false;
        });
    },
    [selectedNotifTab, state.loadingLazy]
  );

  React.useEffect(() => {
    if (state.menu) {
      const tabChanged = previousTabRef.current !== selectedNotifTab;
      previousTabRef.current = selectedNotifTab;

      // If tab changed, always reload data
      if (tabChanged) {
        loadMoreNotifications(1);
      } else {
        // Only load data if we don't have data for the current tab
        const currentData =
          selectedNotifTab === 'all' ? state.DATA : state.unSeenDATA;

        if (
          !currentData ||
          currentData.length === 0 ||
          (typeof notificationCount !== 'object' &&
            notificationCount !== previousNotificationCountRef.current &&
            shouldScrollToTopRef)
        ) {
          loadMoreNotifications(1);
        } else {
          // Restore scroll position when reopening with existing data
          if (
            scrollPositionRef.current > 0 &&
            !shouldScrollToTopRef &&
            contentRef.current
          ) {
            requestAnimationFrame(() => {
              setTimeout(() => {
                if (contentRef.current) {
                  contentRef.current.scrollTop = scrollPositionRef.current;
                }
              }, 100);
            });
          }
        }
      }
      SaveData({ notif: null });
    }
  }, [
    state.menu,
    selectedNotifTab,
    notificationCount,
    state.DATA,
    state.unSeenDATA,
    loadMoreNotifications,
    shouldScrollToTopRef,
  ]);

  // Reset scroll to top when notificationCount changes
  React.useEffect(() => {
    if (
      typeof notificationCount !== 'object' &&
      previousNotificationCountRef.current !== notificationCount &&
      previousNotificationCountRef.current !== null &&
      previousNotificationCountRef.current !== undefined &&
      shouldScrollToTopRef
    ) {
      scrollPositionRef.current = 0;
      setShouldScrollToTopRef(true);
      // Try scrolling immediately if menu is already open
      if (state.menu && contentRef.current) {
        contentRef.current.scrollTop = 0;
      }
    }
  }, [notificationCount, state.menu, shouldScrollToTopRef]);

  const handleScrollTop = useCallback(() => {
    setShouldScrollToTopRef(true);
    const el = contentRef.current;
    if (el && hasMore && !state.loadingLazy && !state.loading) {
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 50) {
        loadMoreNotifications(page + 1);
      }
    }
  }, [state, hasMore, loadMoreNotifications, page]);

  React.useEffect(() => {
    const el = contentRef.current;
    if (el) {
      el.addEventListener('scroll', handleScrollTop);
      return () => {
        el.removeEventListener('scroll', handleScrollTop);
      };
    }
  }, [handleScrollTop]);

  const handleReadAllNotif = () => {
    setState((state) => ({
      ...state,
      loading: true,
    }));
    postNotificationsSeenAll()
      .then((res) => {
        SaveData({ notificationCount: 0 });
        loadMoreNotifications(1);
        // setState((state) => ({
        //   ...state,
        //   // menu: null,
        //   DATA: res.data,
        //   loading: false,
        // }));
      })
      .catch((err) => {
        setState((state) => ({
          ...state,
          loading: false,
        }));
      });
  };

  const Open = (data, seenStatus, doNotOpenLink) => {
    const seen = seenStatus === true ? 1 : seenStatus === false ? 0 : 1;
    console.log('Open', data.id, seen);

    // Generate a unique request ID for this API call
    const requestId = `${data.id}-${Date.now()}-${Math.random()}`;
    pendingRequestsRef.current.set(data.id, requestId);

    (seen ? seenNotif : unSeenNotif)(data.id)
      .then((res) => {
        // Check if this request is still the latest one for this notification
        const currentRequestId = pendingRequestsRef.current.get(data.id);
        if (currentRequestId !== requestId) {
          console.log(
            'Ignoring stale request response for notification',
            data.id
          );
          return; // Ignore stale response
        }

        // Remove the request from pending since it's completed
        pendingRequestsRef.current.delete(data.id);

        setShouldScrollToTopRef(false);

        // Use functional updates to always work with the latest state
        setState((prevState) => {
          const seenedItems =
            selectedNotifTab === 'all'
              ? prevState.DATA.map((item) =>
                  item.id === data.id ? { ...item, seen } : item
                )
              : prevState.unSeenDATA.map((item) =>
                  item.id === data.id ? { ...item, seen } : item
                );
          console.log('seenedItems', seenedItems);
          return {
            ...prevState,
            DATA: selectedNotifTab === 'all' ? seenedItems : prevState.DATA,
            unSeenDATA:
              selectedNotifTab === 'unread'
                ? seenedItems
                : prevState.unSeenDATA,
            menu: doNotOpenLink ? prevState.menu : null,
          };
        });
        SaveData({ notificationCount: res?.notificationCount });

        previousNotificationCountRef.current = res?.notificationCount;
      })
      .catch((err) => {
        // Remove the request from pending on error
        const currentRequestId = pendingRequestsRef.current.get(data.id);
        if (currentRequestId === requestId) {
          pendingRequestsRef.current.delete(data.id);
        }
        console.error('Error updating notification seen status:', err);
      });
    let Item = _get(data, 'data', {});

    if (
      Item.type === 'chat' ||
      Item.type === 'order' ||
      Item.type === 'request'
    )
      !doNotOpenLink &&
        history.push(`/inbox/chat/${Item.order_id}-empty-${user_id}`);
    else if (Item.type === 'containerAppointment') {
      getContainerData(Item.container_id)
        .then((res) => {
          if (res?.message === 'Container does not exist!') {
            !doNotOpenLink && history.push(`/inventory/empty/dropped`);
          } else {
            // const simpleData = extractSimpleContainers([res.containerData]);
            let queryParams = new URLSearchParams({
              apiData: JSON.stringify({
                size: res?.containerData?.cabin?.specification_id,
                ssl: res?.containerData?.cabin?.company_id,
                containerId: res?.containerData?.id,
                cabinId: res?.containerData?.cabin_id,
              }),
              containerData: encodeURIComponent(
                JSON.stringify(res?.containerData)
              ),
            });

            !doNotOpenLink &&
              history.push(
                `/inventory/emptyDropped/appointments?${queryParams}`
              );
          }
        })
        .catch((err) => {
          SaveApiResMessage({
            title: 'Error',
            message: err,
            mode: 'warning',
          });
        });
    } else if (Item.type === 'whatsapp-messages') history.push(`/Ai/chat`);
    else if (Item.type === 'order')
      !doNotOpenLink && history.push(`/inbox/chat/${Item.id}-empty-${user_id}`);
    else if (Item.type === 'request')
      !doNotOpenLink && history.push(`/inbox/chat/${Item.id}-empty-${user_id}`);
  };

  const handleClearAllNotifications = () => {
    // Trigger one exit animation for all cards, then clear list
    setClearingAll(true);
    setTimeout(() => {
      setNotifications([]);
      setClearingAll(false);
    }, 300);
  };

  return (
    <>
      {notifications.length > 0 &&
        createPortal(
          <div className={cls.notificationToast} ref={wrapperRef}>
            {notifications.length > 5 && (
              <span
                onClick={handleClearAllNotifications}
                className="bg-white cursor-pointer text-gray-500 absolute -top-10 right-0 border border-solid border-gray-500 rounded-full text-sm px-4 h-8 flex items-center justify-center">
                Clear All
              </span>
            )}
            {notifications.map((n, idx) => (
              <NotificationCard
                autoClose={n?.autoClose}
                key={n?.id}
                id={n?.id}
                title={n?.title}
                message={n?.message}
                wrapper={n?.wrapper}
                shadow={n?.shadow}
                queryParams={n?.queryParams}
                status={n?.status}
                index={idx}
                totalNotifications={notifications.length}
                isNew={idx === 0}
                opponent={n?.opponent}
                forceExit={clearingAll}
                onClose={(id) => {
                  setNotifications((prev) =>
                    prev.filter((notif) => notif.id !== id)
                  );
                }}
              />
            ))}
          </div>,
          document.body
        )}
      <Button
        className={cls.bellIcon}
        onClick={(e) => {
          setState({ ...state, menu: e.currentTarget });
        }}>
        <span className={cls.notifIcon}>
          <img
            // src={
            //   notif.chat ||
            //   notif.order ||
            //   notif.request ||
            //   notif['whatsapp-messages']
            //     ? HeaderIcons.notification
            //     : HeaderIcons.notificationBadge
            // }
            src={HeaderIcons.notification}
            alt="NotificationIcon"
          />
        </span>
        {notificationCount > 0 && notificationCount < 99 ? (
          <span className={cls.notifIconCount}>{`${notificationCount}`}</span>
        ) : notificationCount >= 99 ? (
          <span className={cls.notifIconCount}>{`99+`}</span>
        ) : null}
      </Button>
      <Menu
        elevation={1}
        keepMounted
        anchorEl={state.menu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        getContentAnchorEl={null}
        open={Boolean(state.menu)}
        onClose={() => {
          // Save scroll position before closing
          if (contentRef.current) {
            scrollPositionRef.current = contentRef.current.scrollTop;
          }
          setState({ ...state, menu: null });
          setTimeout(() => {
            setSelectedNotifTab('all');
          }, 500);
        }}
        classes={{ list: cls.list }}
        PaperProps={{
          style: {
            border: '1px solid #E1E4EA',
            top: '10px !important',
            borderRadius: 4,
            overflow: 'hidden',
            ...(window.innerWidth > 800 && { translate: '125px 8px' }),
          },
        }}>
        <div className={cls.notiTitle}>
          <span className={cls.notiTitleSpan}>
            <span className={cls.notiTitleText}>Notifications</span>
            <span className={cls.notiTitleNumber}>
              {`(${
                notificationCount > 0 && notificationCount < 99
                  ? notificationCount
                  : notificationCount >= 99
                  ? '99+'
                  : 0
              })` || '(0)'}
              {/* (
              {(selectedNotifTab === 'all' ? state.DATA : state.unSeenDATA)
                ?.length || 0}
              ) */}
            </span>
          </span>
          <span className={cls.notiTitleSpan}>
            <span
              className={cls.notiSeeAllIcon}
              onClick={() => handleReadAllNotif()}>
              <ReactSVG src={Icons.readAll} />
            </span>
            {notifMute === true ? (
              <span
                className={cls.notiMuteIcon}
                onClick={() => handleMuteNotif(false)}>
                <ReactSVG src={Icons.mute} />
              </span>
            ) : notifMute === false ? (
              <span
                className={cls.notiMuteIcon}
                onClick={() => handleMuteNotif(true)}>
                <ReactSVG src={Icons.unMute} />
              </span>
            ) : null}
          </span>
        </div>
        <div className={cls.notiTabs}>
          <span className={cls.notiTitleSpan}>
            <span
              className={
                selectedNotifTab === 'all'
                  ? cls.notiTitleTabsActive
                  : cls.notiTitleTabs
              }
              onClick={() => {
                setSelectedNotifTab('all');
                setPage(1);
                setHasMore(true);
                scrollPositionRef.current = 0;
                setShouldScrollToTopRef(true);
              }}>
              All
            </span>
            <span
              className={
                selectedNotifTab === 'unread'
                  ? cls.notiTitleTabsActive
                  : cls.notiTitleTabs
              }
              onClick={() => {
                setSelectedNotifTab('unread');
                setPage(1);
                setHasMore(true);
                scrollPositionRef.current = 0;
                setShouldScrollToTopRef(true);
              }}>
              Unread
            </span>
          </span>
        </div>

        {state.loading && page === 1 ? (
          <div className={cls.loading}>
            <LoadingV2 />
          </div>
        ) : (selectedNotifTab === 'all' ? state.DATA : state.unSeenDATA)
            ?.length === 0 ? (
          <div className={cls.loading}>
            <div className={cls.empty}>You have no new notification</div>
          </div>
        ) : (
          <div>
            <div ref={contentRef} className={clsx('scroll-bar', cls.content)}>
              {(selectedNotifTab === 'all'
                ? state.DATA
                : state.unSeenDATA
              )?.map((data, idx) => (
                <Card DATA={data} key={idx} Open={Open} />
              ))}
              {state.loadingLazy && page > 1 && (
                <div className={cls.loadingLazy}>
                  <LoadingV2 />
                </div>
              )}
            </div>
          </div>
        )}
      </Menu>
    </>
  );
};
